// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import config from '../../auth_config.json';

const { domain, clientId, authorizationParams: { audience }, apiUri, errorPath } = config as {
  domain: string;
  clientId: string;
  authorizationParams: {
    audience?: string;
  },
  apiUri: string;
  errorPath: string;
};

export const environment = {
  production: false,
  apiUrl: "https://api.alfa-hostal-qa.cubearshop.com/",
  // apiUrl: "https://localhost:5001/",
  auth: {
    domain,
    clientId,
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://smarthotel', // 👈 debe coincidir con el "Identifier" en tu API de Auth0
    }
  },
  httpInterceptor: {
    allowedList: [
      `${apiUri}/*`,
      {
        uri: `${apiUri}/*`,
        tokenOptions: {
          authorizationParams: {
            audience: 'https://smarthotel',
          }
        }
      }
    ]
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
